import { service } from '@ember/service'
import Route from '@ember/routing/route'
import type SchoolRolloverService from 'teacher-ui-client/services/school-rollover'
import { assert } from '@ember/debug'

export default class StepsRoute extends Route {
  @service
  schoolRollover!: SchoolRolloverService

  model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute

    const rollover = this.schoolRollover.activeRolloverForSubco(subscriptionType)
    assert(`could not find active rollover for ${subscriptionType} subscription type`, rollover)

    return {
      currentSubscriptionType: subscriptionType,
      rollover: rollover,
    }
  }
}
